import React from "react";
import { useDispatch, useSelector } from "react-redux";
import classNames from "classnames";
import { CustomCol, FrameItem } from "../../framesQr/QrFrameItems";
import { qrResetText } from "../../../../../redux/slices/qrTextSettings";
import { qrResetSettings } from "../../../../../redux/slices/qrSettings";
import { qrResetFrame } from "../../../../../redux/slices/qrFrames";
import NoTemplate from "../svg/NoTemplate";
import { setActivePremadeTemplateId } from "../../../../../redux/slices/preMadeTemplates";

export default function NoTemplateBtn() {
  const { frame } = useSelector((state) => ({
    frame: state.qrFrames.frame,
  }));
  const dispatch = useDispatch();

  const handleResetActiveTemplate = () => {
    dispatch(setActivePremadeTemplateId(null));
    dispatch(qrResetText());
    dispatch(qrResetSettings());
    dispatch(qrResetFrame());
  };

  return (
    <CustomCol>
      <FrameItem
        className={classNames(
          "d-flex justify-content-center align-items-center border rounded-1 p-2 h-100 flex-column",
          {
            "border-primary": frame === "noFrame",
            "border-border-gray": frame !== "noFrame",
          }
        )}
        onClick={handleResetActiveTemplate}
      >
        <NoTemplate />
      </FrameItem>
    </CustomCol>
  );
}
